(function () {
    'use strict';

    function crmAccountEditorController($scope, $log, $timeout, $rootScope, $location,
        sessionData, entity) {

        var vm = this;
        vm.sessionData = sessionData;
        vm.entity = entity;
        vm.ReplaceFile = false;

        vm.allowedLogoUploadFileExtensions = ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'svg'];

        $rootScope.$on('fileUploaded', function (event, args) {
            vm.entity.Logo = args.blobs[0];
            vm.ReplaceFile = true;
        });

        vm.tinymceOptions = {
            height: "300",
            menubar: false,
            statusbar: false,
            resize: false,
            plugins: [
                "advlist autolink link paste"
            ],
            advlist_bullet_styles: "disc",
            toolbar: "undo redo | bold italic | bullist | link",
            valid_elements: '*[*]',
            debounce: true
        };
    }

    crmAccountEditorController.$inject = ['$scope', '$log', '$timeout', '$rootScope', '$location',
        'sessionData', 'entity'];

    angular.module('ecap.dashboards').controller('crmAccountEditorController', crmAccountEditorController);
})();
